import { faqItems } from '../../../content/healthModalsContent';
import { sideNavUsp } from './constants/sideNavUsp';

const summary = {
  name: 'summary',
  localState: {
    wizardSteps: [],
    pageError: '',
  },
  components: [
    {
      type: 'PageLayout',
      props: {
        bg: 'comparatorBG',
        header: [
          {
            type: 'PageHeader',
            props: {
              faq: {
                buttonLabel: 'Veelgestelde vragen',
                buttonIcon: 'comment',
                title: 'Veelgestelde vragen',
                items: faqItems,
                hideLabelOnMobile: true,
              },
              activeStep: 2,
            },
          },
        ],
        sideNav: [
          {
            type: 'ProductSummaryHealth',
            props: {
              display: ['none', 'none', 'block', 'block'],
              width: '310px',
              css: {
                boxSizing: 'content-box',
              },
              mt: '3.4rem',
              fieldName: 'overview.selectedProduct',
              bg: 'white',
              boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.15) !important',
              padding: 5,
              borderRadius: 2,
              goToApplyPage: {
                buttonLabel: 'Aanvragen',
              },
              showTransparency: false,
              promotionBarModals: {
                containerStyles: {
                  display: 'flex',
                  justifyContent: 'center !important',
                  marginTop: '24px',
                  padding: '8px 24px',
                  borderRadius: '16px',
                  '> div:first-child': {
                    padding: '0',
                  },
                },
                items: [
                  {
                    modal: {
                      contentType: 'incentive',
                      title: 'Unieke Tandongevallen-verzekering',
                      buttonSubtitle: 'Met een dekking tot € 25.000',
                      buttonIcon: 'tooth',
                      buttonIconProps: {
                        width: 18,
                        height: 18,
                        minWidth: 'unset',
                        css: {
                          flexShrink: 0,
                        },
                      },
                      content: [
                        {
                          type: 'BolContent',
                        },
                      ],
                    },
                  },
                ],
              },
            },
          },
          sideNavUsp({ display: ['none', null, 'block'] }),
        ],
        subHeader: [
          {
            type: 'ProductSummaryHealth',
            props: {
              left: '0',
              bottom: '0',
              width: 'fill-available',
              position: 'fixed',
              display: ['block', 'block', 'block', 'none'],
              fieldName: 'overview.selectedProduct',
              backgroundColor: 'main.0',
              borderTopLeftRadius: '24px !important',
              borderTopRightRadius: '24px !important',
              boxShadow: '0px -4px 10px 0px rgba(62, 72, 101, 0.10)',
              p: [3, null, 5],
              borderRadius: 2,
              goToApplyPage: {
                buttonLabel: 'Aanvragen',
              },
              showTransparency: false,
              promotionBarModals: {
                containerStyles: {
                  display: 'flex',
                  justifyContent: 'center !important',
                  marginTop: '24px',
                  padding: '8px 24px',
                  borderRadius: '16px',
                  '> div:first-child': {
                    padding: '0',
                  },
                },
                items: [
                  {
                    modal: {
                      contentType: 'incentive',
                      title: 'Unieke Tandongevallen-verzekering',
                      buttonSubtitle: 'Met een dekking tot € 25.000',
                      buttonIcon: 'tooth',
                      buttonIconProps: {
                        width: 18,
                        height: 18,
                        minWidth: 'unset',
                        css: {
                          flexShrink: 0,
                        },
                      },
                      content: [
                        {
                          type: 'BolContent',
                        },
                      ],
                    },
                  },
                ],
              },
            },
          },
        ],
        content: [
          {
            type: 'SummaryPage',
            props: {
              fieldNames: [
                'getUserInput.deductibleAmount',
                'getUserInput.birthdate',
                'getUserInput.postcode',
                'getUserInput.gender',
                'getUserInput.partnerBirthdate',
                'getUserInput.partnerGender',
                'getUserInput.coverageadditions',
                'getUserInput.childBirthdate1',
                'getUserInput.childBirthdate2',
                'getUserInput.childBirthdate3',
                'getUserInput.childBirthdate4',
                'getUserInput.childBirthdate5',
                'getUserInput.childGender1',
                'getUserInput.childGender2',
                'getUserInput.childGender3',
                'getUserInput.childGender4',
                'getUserInput.childGender5',
              ],
            },
          },
          sideNavUsp({ mb: '130px', display: ['block', null, 'none'] }),
        ],
        sideNavProps: {
          position: 'sticky',
          top: '20px',
          alignSelf: 'start',
        },
      },
    },
  ],
};

export default summary;
